<form [formGroup]="customFieldsForm" class="ps-0 pe-0">
  <div class="row mb-lg-2">
    <div
      *ngFor="let customFieldDynamic of dynamicFormCustomFields; let i = index"
      class="col-12 mb-3 mb-lg-0"
      [ngClass]="{ 'd-flex flex-row align-items-center': customFieldDynamic.FieldType == 2 }"
    >
      <!--TextBox-->
      <div class="form-floating mb-1">
        <input
          [ngClass]="{
            'is-invalid': (customFieldsForm.controls[i].dirty || hasSumbittedForm) && !!customFieldsForm.controls[i].errors
          }"
          type="text"
          class="custom-field-form form-control field"
          [id]="'customField_' + i"
          placeholder=""
          [formControl]="customFieldsForm.controls[i]"
        />
        <label class="display-name-custom-field" for="floatingInputCustomField">{{ customFieldDynamic.DisplayName }}</label>
      </div>

      <!--Limit-->
      <div class="float-end">
        <div class="text-info font-size-12">
          {{ customFieldsForm.controls[i].value.length }}/{{ customFieldDynamic.CharacterLimit }}
        </div>
      </div>

      <!--Errors-->
      <div
        class="error-messages alert-danger text-start"
        *ngIf="(customFieldsForm.controls[i].dirty || hasSumbittedForm) && customFieldsForm.controls[i].errors"
      >
        <div *ngIf="customFieldsForm.controls[i].errors!.required">{{ 'custom.field.error.required' | translate }}</div>
        <div *ngIf="customFieldsForm.controls[i].errors!.maxlength!">
          {{ 'custom.field.error.maxlength' | translate }} ({{ customFieldsForm.controls[i].errors!.maxlength.actualLength }}/{{
            customFieldsForm.controls[i].errors!.maxlength.requiredLength
          }})
        </div>
        <div *ngIf="customFieldsForm.controls[i].errors!.pattern">{{ 'custom.field.error.validate' | translate }}</div>
      </div>
    </div>
  </div>
</form>
